export const addisonNotifNewItemsFmt = "BIyL_d";
export default {addisonNotifNewItemsFmt};